import React from 'react';
import { useModalClose } from '../../utils/useModalClose';

type ConfirmModalProps = {
  close: () => void;
  reject: () => void;
  title: string;
  buttonText: string;
};

export const WarningModal: React.FC<ConfirmModalProps> = ({
  close,
  reject,
  title,
  buttonText,
}) => {
  const modalRef = useModalClose(reject);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={() => close()} />
        </div>
        <div className="modal-body pt-2 p-4">
          <div className="text-center mb-4 mx-auto">
            <i className="bi bi-exclamation-circle-fill color-yellow fs-65 lh-1" />
            <h3 className="mt-3">{title}</h3>
          </div>
          <button
            type="button"
            className="btn btn-success w-100 mb-3"
            onClick={() => close()}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};
